// DrawerIssueBindingCodeForm — AI mode 抽屜版「產生邀請碼」 表單。
//
// 走 propose_drawer_form({ kind: "issue_binding_code" }) 開啟。沿用
// BindingCodeIssueForm 的內裡（角色 / TTL / 備註欄位 + POST /v1/invites
// 邏輯）— 唯一差別在於「產出之後」 不在抽屜裡顯示 IssuedCard、而是
// 把產出資料以 DrawerFormOutcome 帶出，由 ChatBubble 將 QR / 8 字碼
// 以本地 non-persisted 卡片插入對話。
//
// 8 字碼是短期 credential — 絕對不送回 OpenAI（tool_result 只給
// {accepted:true, kind:"issue_binding_code", code_issued:true}）。

import React from "react";
import { BindingCodeIssueForm, type IssuedCode } from "../components/BindingCodeIssueModal.js";

export default function DrawerIssueBindingCodeForm({
  prefill,
  onSaved,
  onCancel,
}: {
  prefill: Record<string, unknown>;
  /** Fires with the issued code. Caller is responsible for closing the
   *  drawer + injecting the chat bubble. */
  onSaved: (issued: IssuedCode) => void;
  onCancel: () => void;
}): React.ReactElement {
  const defaultRole = typeof prefill.role === "string" ? prefill.role : "manager";

  return (
    <BindingCodeIssueForm
      defaultRole={defaultRole}
      onIssued={onSaved}
      onCancel={onCancel}
    />
  );
}
